import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { ImChannelProactivityExperiment } from '@/features/im-channel-proactivity-experiments/im-channel-proactivity-experiments-types';

type SendExperimentDialogProps = {
  experiment: ImChannelProactivityExperiment;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
};

/** Confirms a delayed send to the currently enabled cohort. */
export const SendExperimentDialog = ({
  experiment,
  onConfirm,
  onOpenChange,
}: SendExperimentDialogProps) => (
  <Dialog open onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Send {experiment.title}?</DialogTitle>
        <DialogDescription>
          This will send the experiment to the enabled cohort in about 2
          minutes.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <DialogClose asChild>
          <Button type="button" variant="outline">
            Cancel
          </Button>
        </DialogClose>
        <Button type="button" onClick={onConfirm}>
          Send in 2 minutes
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
